import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/App';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Crown } from 'lucide-react';
import AdminTeamManagement from '@/components/AdminTeamManagement';

const SUPER_ADMIN_EMAIL = "georgebroughton71@gmail.com";

export default function AdminTeamPage() {
  const navigate = useNavigate();
  const { user, token } = useAuth();
  
  // Check authorization synchronously
  const isAuthorized = user?.email?.toLowerCase() === SUPER_ADMIN_EMAIL.toLowerCase();

  useEffect(() => {
    // Redirect non-super admins
    if (user && !isAuthorized) {
      navigate('/admin');
    }
  }, [user, isAuthorized, navigate]);

  if (!user) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-zinc-400">Loading...</p>
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-zinc-400">Redirecting...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="bg-zinc-900 border-b border-zinc-800 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button 
                variant="ghost" 
                size="sm"
                onClick={() => navigate('/admin')}
                className="text-zinc-400 hover:text-white"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Admin
              </Button>
              <div className="flex items-center gap-2">
                <Crown className="w-6 h-6 text-amber-400" />
                <h1 className="text-xl font-bold text-white">Team Management</h1>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        <AdminTeamManagement />
      </main>
    </div>
  );
}
